import { motion } from "motion/react";
import { BaseSyntheticEvent, useCallback, useEffect, useRef } from "react";
import clsx from "clsx";
import { ChatTarget, fontSizeClass, fontWeightClass } from "@/domains/chat/constants/chat.ts";
import { highlightSearchText, removeHighlights } from "@/domains/chat/helpers/highlightSearchText";
import { MessageProps } from "@/domains/chat/helpers/messageProps";
import ChatBorderMessage from "@/domains/chat/components/chat/messages/ChatBorderMessage";
import { MessageComponent } from "@/domains/chat/components/chat/messages/MessageComponent";

type Props = MessageProps & {
  searchValue?: string;
  onCopy?: (value: string) => void;
  isOpacityMode?: boolean;
};

export default function ChatMessage({
  message,
  isOpacityMode,
  onCopy,
  settings,
  searchValue,
}: Props) {
  const needToRemoveHightlights = useRef<boolean>(false); // нужен для того чтобы removeHighlights не происходил у сообщений у которых не был выделен текст
  const copyHandler = useCallback(
    (e: BaseSyntheticEvent<HTMLDivElement>) => {
      e.preventDefault();
      const content = document
        .getElementById(message.uid)
        .outerHTML.replace(/<[^>]*>/g, "")
        .replace(/&[^;]+;/g, " "); // для удаления специ сиволов типа &amp; и &nbsp;
      onCopy(content);
    },
    [message.uid, onCopy],
  );

  // const isMyMessage =
  //   settings.highlightOwnMessages &&
  //   Boolean(message?.player?.me) &&
  //   [
  //     ChatTarget.Speaking,
  //     ChatTarget.SpeakingOoc,
  //     ChatTarget.Shout,
  //     ChatTarget.Whisper,
  //     ChatTarget.SpeakEmote,
  //   ].includes(message.message.target);

  useEffect(() => {
    const messageElement = document.getElementById(message.uid);
    if (messageElement) {
      if (searchValue) {
        needToRemoveHightlights.current = true;
        highlightSearchText(messageElement, searchValue);
      } else if (needToRemoveHightlights.current) {
        removeHighlights(messageElement);
        needToRemoveHightlights.current = false;
      }
    }
  }, [message.uid, searchValue]);

  const Component = MessageComponent[message.message.target];

  if (Component)
    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
      <motion.div
        initial={{
          opacity: 0,
          height: 0,
          translateX: "-100%",
        }}
        animate={{
          opacity: 1,
          translateX: "none",
          height: "auto",
        }}
        transition={{
          duration: 0.1,
        }}
        className={clsx(
          "flex items-start gap-2 shrink-0",
          "cursor-pointer overflow-clip",
          fontSizeClass[settings.fontSize],
          fontWeightClass[settings.fontWeight],
        )}
        id={message.uid}
        onClick={copyHandler}
      >
        <ChatBorderMessage target={message.message.target} isOpacityMode={isOpacityMode}>
          {/* {isMyMessage && <div className={clsx("h-full w-[3px] rounded-[2px] bg-[#4EE966]")} />} */}
          <Component message={message} settings={settings} />
        </ChatBorderMessage>
      </motion.div>
    );

  return (
    <div
      className={clsx(
        "flex items-center gap-2 font-bold text-red-300 stroke shrink-0",
        fontSizeClass[settings.fontSize],
      )}
    >
      <div className={clsx("h-full w-[3px] rounded-[2px]")} />
      CEF ERROR: NO_COMPONENT_FOR_MESSAGE
    </div>
  );
}
